import React from 'react';
import { EditorState } from 'draft-js';

import { AuthorisationConsumer } from '../../../../AuthorisationWrapper';
import { UploaderConsumer } from '../../../../Uploader';
import { CommentsConsumer } from '../../../contexts/commentsContext';
import CommentTextEditorV2Component from '../components/CommentTextEditorV2';





















function CommentTextEditorV2(props) {
  return (
    <AuthorisationConsumer>
      {({ isShootstaUser }) =>
      <UploaderConsumer>
          {({ addFilesToQueue }) =>
        <CommentsConsumer>
              {({
            state: {
              resourceOrganisationId,
              organisationName,
              allowedWriteVisibilityOptions
            }
          }) =>
          <CommentTextEditorV2Component
            {...props}
            addFilesToQueue={addFilesToQueue}
            organisationId={resourceOrganisationId}
            isShootstaUser={isShootstaUser}
            organisationName={organisationName}
            allowedWriteVisibilityOptions={allowedWriteVisibilityOptions} />}


            </CommentsConsumer>}

        </UploaderConsumer>}

    </AuthorisationConsumer>);

}

export default CommentTextEditorV2;